import { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { LoadingSkeleton } from "@/components/shared";
import { PageTransition } from "./PageTransition";
import { ScrollToTop } from "./ScrollToTop";
import Index from "@/pages/Index";

// Lazy load all other pages
const Shop = lazy(() => import("@/pages/Shop"));
const Product = lazy(() => import("@/pages/Product"));
const DirectCheckout = lazy(() => import("@/pages/DirectCheckout"));
const Success = lazy(() => import("@/pages/Success"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Contact = lazy(() => import("@/pages/Contact"));
const NotFound = lazy(() => import("@/pages/NotFound"));

export const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          <PageTransition>
            <Index />
          </PageTransition>
        } />
        <Route path="/shop" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <PageTransition>
              <Shop />
            </PageTransition>
          </Suspense>
        } />
        <Route path="/product/:handle" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <PageTransition>
              <Product />
            </PageTransition>
          </Suspense>
        } />
        <Route path="/success" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <PageTransition>
              <Success />
            </PageTransition>
          </Suspense>
        } />
        <Route path="/faq" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <PageTransition>
              <FAQ />
            </PageTransition>
          </Suspense>
        } />
        <Route path="/contact" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <PageTransition>
              <Contact />
            </PageTransition>
          </Suspense>
        } />
        <Route path="/buy/:handle" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <PageTransition>
              <DirectCheckout />
            </PageTransition>
          </Suspense>
        } />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={
          <Suspense fallback={<LoadingSkeleton />}>
            <PageTransition>
              <NotFound />
            </PageTransition>
          </Suspense>
        } />
      </Routes>
      </AnimatePresence>
    </>
  );
};
